/** Belge açma ve erişim günlüğü metinleri. */

import type { TranslationBundle } from '../../shell/bridge.ts';

export const TEXTS: TranslationBundle = {
  en: {
    fa_fail: 'The document could not be opened. Please try again.',
    fa_log_t: 'Document access',
    fa_log_d: 'Every time your accountant or their team opens one of your documents, it is recorded here. The record cannot be edited or deleted.',
    fa_log_none: 'No one has opened your documents yet.',
    fa_log_fail: 'The access history could not be loaded.',
    fa_opened: 'opened',
    fa_downloaded: 'downloaded',
  },
};
